module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAESSURBVHgB1VPRbcJADH2+ZAC6QTpB6QSFCdrvCtpkg2zQFfrdChI2CBPABogNMgILEPNOEHJARE5CfPCk3Mn287Ojs4GHxViz9FszHesk7eIaD8L7/jYvXdywzTnS7MNABwbyq44/1iyi/SPAPJek8BILmABIv0K1Ead52jHtmIIDmkXLXxyr9kb6b0lQ6BM88Kl/fdvtRWestgoQRgwOK2inkC1M/oLMkubzSWdEZI8tqggeEBZ2887FbsbdxEp7BDClT2Jw4KO5GzHOzpDfK+dnCQ9YXp1T+0InWMIfm1rQdbYOLSc/5XhwC0zOp39r/Canv8f4si1P0IEvnRYCsfuZzyRJrnE9Fn3fBauu8bDYAegaT1tUyHBdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/Images/frequencyicon.png
// module id = 1121
// module chunks = 0